export default "__VITE_ASSET__CejYQTfF__"